import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Home from 'src/views/landingPage/Home/Home';
import AboutUs from 'src/views/landingPage/AboutUs/AboutUs';
import ContractsAndLegal from '../views/landingPage/ContractsAndLegal/ContractsAndLegal';
import EventsWebinars from '../views/landingPage/EventsWebinars/EventsWebinars';
import EventsWebinarsSeasons from '../views/landingPage/EventsWebinarsSeasons/eventsWebinarsSeasons';
import Library from '../views/landingPage/Library/Library';
import Media from '../views/landingPage/Media/Media';
import ShareholderAndCommunity from '../views/landingPage/ShareholderAndCommunity/ShareholderAndCommunity';
import Login from 'src/views/landingPage/Login/Login';
import ForgotPassword from '../components/shared/password/forgotPassword/forgotPassword';
import ResetPassword from '../components/shared/password/resetPassword/resetPassword';
import Terms from '../components/Layout/Terms/Terms';
import Privacy from '../components/Layout/Privacy/Privacy';
import { LayoutWrapper } from '../components/Layout/LayoutWrapper/LayoutWrapper';
import { OnboardingApplicantRoutes } from 'src/routes/applicant/OnboardingApplicantRoutes';
import { DashboardApplicantRoutes } from 'src/routes/applicant/DashboardApplicantRoutes';
import { OnboardingInvestorRoutes } from 'src/routes/investor/OnboardingInvestorRoutes';
import SignupInvestor from 'src/views/landingPage/SignupInvestor/SignupInvestor';
import { DashboardInvestorRoutes } from 'src/routes/investor/DashboardInvestorRoutes';
import SignupApplicant from 'src/views/landingPage/SignupApplicant/SignupApplicant';
import MainSignup from 'src/components/shared/Signup/mainSignup';
import ApplicantHome from 'src/components/features/applicant/homeLogin/homeLogin';
import { NotFound } from 'src/views/shared/NotFound/NotFound';
import { TestView } from 'src/views/TestView/TestView';
import { ProtectedRoute } from './ProtectedRoute';
import { ConfirmationAccount } from 'src/views/landingPage/ConfirmationAccount/ConfirmationAccount';
import { ThreatValidation } from 'src/views/landingPage/ThreatsTrully/Threat';

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<LayoutWrapper />}>
          {/* Landing */}
          <Route path="/" element={<Home />} />
          <Route
            path="/iniciar-sesion"
            element={
              <ProtectedRoute redirectPath="/" isReturnPath={false} invertedProtected>
                <Login />
              </ProtectedRoute>
            }
          />
          <Route path="/terminos-y-condiciones" element={<Terms />} />
          <Route path="/aviso-de-privacidad" element={<Privacy />} />
          <Route path="/quienes-somos" element={<AboutUs />} />
          <Route path="/media" element={<Media />} />
          <Route path="/eventos-webinars" element={<EventsWebinars />} />
          <Route path="/biblioteca" element={<Library />} />
          <Route path="/nuestros-servicios" element={<Library />} />
          <Route path="/relacion-con-accionistas-comunidad" element={<ShareholderAndCommunity />} />
          <Route path="/contratos-y-legal" element={<ContractsAndLegal />} />
          <Route path="/eventos-webinars-temporadas" element={<EventsWebinarsSeasons />} />
          <Route path="/:usuario/olvide-contraseña" element={<ForgotPassword />} />
          <Route path="/reestablecer-contraseña" element={<ResetPassword />} />
          <Route
            path="/inversionista/registrate"
            element={
              <ProtectedRoute redirectPath="/" isReturnPath={false} invertedProtected>
                <SignupInvestor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/solicitante/registrate"
            element={
              <ProtectedRoute redirectPath="/" isReturnPath={false} invertedProtected>
                <SignupApplicant />
              </ProtectedRoute>
            }
          />
          <Route path="/validation-page" element={<ThreatValidation />} />
          <Route path="/registro" element={<MainSignup />} />
          <Route path="/solicitante/inicio" element={<ApplicantHome />} />
          <Route path="/confirmar-cuenta" element={<ConfirmationAccount />} />
          {OnboardingApplicantRoutes}
          {DashboardApplicantRoutes}
          {OnboardingInvestorRoutes}
          {DashboardInvestorRoutes}
          {/* Testing, please don't production */}
          <Route path="/test" element={<TestView />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default Router;
